import type { ChangeEvent } from 'react';
import { useEffect, useState } from 'react';

function numberOrUndefined(value: number) {
  return Number.isNaN(value) ? undefined : value;
}

/* Tracks the state of a string and returns a valid number or undefined */
export const useValidNumber = (
  value: number | undefined,
  onValueChanged: (newValue: number | undefined) => void,
): [string, (event: ChangeEvent<HTMLInputElement>) => void] => {
  const [numberInputValue, setNumberInputValue] = useState<string>(
    value === undefined ? '' : value.toString(),
  );

  useEffect(() => {
    if (value === undefined) return;
    setNumberInputValue(`${value}`);
  }, [value]);

  useEffect(() => {
    const newValue = numberOrUndefined(parseFloat(numberInputValue));
    if (newValue === value) return;
    onValueChanged(newValue);
  }, [numberInputValue, onValueChanged, value]);

  const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setNumberInputValue(event.target.value);
  };

  return [numberInputValue, onInputChanged];
};
